import React, { useState, useEffect, Fragment } from "react";
import ReceiptsAdmisionsList from "./ReceiptsAdmisionsList";
import ReceiptsAdmisionsListActions from "./ReceiptsAdmisionsListActions";

const ReceiptsAdmissions = ({ admision, estadoFacturacion }) => {
  const [receipts, setReceipts] = useState([]);

  const loadCancelledAdmisions = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "reciboscaja/consultar-recibos-por-admision?id_admision=" +
        admision.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setReceipts(res);
      })
      .catch((error) => {
        console.error("Error:", error);
        setReceipts([]);
      });
  };
  useEffect(() => {
    loadCancelledAdmisions();
  }, []);

  const ListCancelledReceipts = () => {
    return (
      <ReceiptsAdmisionsList
        reactTableData={receipts}
        ReactTableActions={ReceiptsAdmisionsListActions}
        admision={admision}
        refreshList={loadCancelledAdmisions}
      />
    );
  };

  return (
    <Fragment>
      <div>
        <div className="subtitle-general">
          <h4 style={{ margin: "0.25em 1em" }}>Recibos de la admisión</h4>
        </div>
        <ListCancelledReceipts />
      </div>
    </Fragment>
  );
};

export default ReceiptsAdmissions;
